import $http from '../../../axios-instance';
import Swal from 'sweetalert2'

/**
 * Método para obtener las bases de una generales.
 *
 * @param {*} param0
 */
export async function getBases({ commit, state, rootState, dispatch }){
    var empresa = rootState.empresa.selectedEmpresa.id;

    await $http.get(`empresas/bases/${empresa}`)
        .then((response) => {
            state.selectedBases.bases_ori = response.data.data;
            commit('cargarBases', response.data.data)
        })
        .catch((error) => {

        })
}

/**
 * Método para guardar las bases de una generales.
 *
 * @param {*} param0
 */
export async function guardaBases({ commit, state, rootState, dispatch }){
    var empresa = rootState.empresa.selectedEmpresa.id;
    await $http.post(`empresas/bases/crear/${empresa}` , state.selectedBases)
            .then((response)=> {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 3000
                });
                state.selectedBases.descripcion = '';
                dispatch('getBases');
                //dispatch('getBasesAreas');
                //state.error = false;
            })
            .catch((error) => {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.errors,
                    showConfirmButton: true,
                    timer: 5000
                })
                reject(error);
            })
}

/**
 * Método para editar las bases de una generales.
 *
 * @param {*} param0
 */
export async function editaBases({ commit, state, rootState, dispatch }){
    var empresa = rootState.empresa.selectedEmpresa.id;

    await $http.put(`empresas/bases/editar/${empresa}` , state.selectedBases)
        .then((response)=> {
            if(response.status == 200){
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 3000
                })
                dispatch('getBases');
                //dispatch('getBasesAreas');
                state.selectedBases.updateBase = false;
                state.selectedBases.descripcion = '';
            }
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            })
            reject(error);
        })
}

/**
 * Método para cambiar el estado de una base en especifico.
 *
 * @param {*} param0
 * @param {*} base trae la informacion de la base a editar.
 */
export async function activarBases({ commit, state, rootState, dispatch }, base){
    var empresa = rootState.empresa.selectedEmpresa.id;

    await $http.put(`empresas/bases/editarEstado/${empresa}` , base)
        .then((response)=> {
            if(response.status == 200){
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 3000
                })
                dispatch('getBases');
                state.selectedBases.updateBase = false;
            }
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            })
            reject(error);
        })
}

/**
 * Método para obtener las áreas de una generales.
 *
 * @param {*} param0
 */
export async function getAreas({ commit, state, rootState }){

    var empresa = rootState.empresa.selectedEmpresa.id;

    await $http.get(`empresas/areas/${empresa}`)
        .then((response) => {
            state.selectedAreas.areas_ori = response.data.data;
            commit('cargarAreas', response.data.data)
        })
        .catch((error) => {

        })
}

/**
 * Método para guardar las áreas de una generales.
 *
 * @param {*} param0
 */
export async function guardaAreas({ commit, state, rootState, dispatch }){
    var empresa = rootState.empresa.selectedEmpresa.id;

    await $http.post(`empresas/areas/crear/${empresa}` , state.selectedAreas)
            .then((response)=> {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 3000
                })
                dispatch('getAreas');
                state.selectedAreas.descripcion = '';
                //dispatch('getBasesAreas');
                //state.error = false
            })
            .catch((error) => {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.errors,
                    showConfirmButton: true,
                    timer: 5000
                })
                reject(error);
            })
}

/**
 * Método para editar las áreas de una generales.
 *
 * @param {*} param0
 */
export async function editaAreas({ commit, state, rootState, dispatch }){
    var empresa = rootState.empresa.selectedEmpresa.id;

    await $http.put(`empresas/areas/editar/${empresa}` , state.selectedAreas)
        .then((response)=> {
            if(response.status == 200){
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 3000
                })
                dispatch('getAreas');
                //dispatch('getBasesAreas');
                state.selectedAreas.updateArea = false
                state.selectedAreas.descripcion = '';
            }
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            })
            reject(error);
        })
}

/**
 * Método para cambiar el estado de un área en especifico.
 *
 * @param {*} param0
 * @param {*} area contiene la información del area a cambiar.
 */
export async function activarAreas({ commit, state, rootState, dispatch }, area){
    var empresa = rootState.empresa.selectedEmpresa.id;

    await $http.put(`empresas/areas/editarEstado/${empresa}` , area)
        .then((response)=> {
            if(response.status == 200){
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 3000
                })
                dispatch('getAreas');
                state.selectedAreas.updateArea = false;
            }
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            })
            reject(error);
        })
}

/**
 * Método para obtener las bases y areas combinadas de una generales.
 *
 * @param {*} param0
 */
export async function getBasesAreas({ commit, state, rootState, dispatch }){
    var empresa = rootState.empresa.selectedEmpresa.id;

    await $http.get(`empresas/bases_areas/${empresa}`)
        .then((response) => {
            state.selectedBasesAreas.bases_areas_ori = response.data.bases_areas;
            state.selectedBasesAreas.bases_areas_sinfil = response.data.bases_areas;

            commit('cargarBasesAreas', response.data.bases_areas);
        })
        .catch((error) => {

        })
}

/**
 * Método para asignar bases y áreas a una generales en especificó.
 *
 * @param {*} param0
 * @param {*} base_area contiene la información de las bases y áreas a asignar.
 */
export async function asignarBasesAreas({ commit, state, rootState, dispatch }, base_area){
    var empresa = rootState.empresa.selectedEmpresa.id;

    await $http.post(`empresas/bases_areas/${empresa}` , base_area)
            .then((response)=> {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 3000
                })
                dispatch('getBasesAreas');
                //state.error = false
            })
            .catch((error) => {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.errors,
                    showConfirmButton: true,
                    timer: 5000
                })
                reject(error);
            })
}

/**
 * Método para seleccionar y asignar todas las bases y áreas a una generales.
 *
 * @param {*} param0
 */
export async function seleccionarTodos({ commit, state, rootState, dispatch }){
    var empresa = rootState.empresa.selectedEmpresa.id;

    if (state.selectedBasesAreas.seltodos && confirm(`¿Está seguro de asignar todas las bases y areas a esta empresa?`)) {
        await $http.post(`empresas/bases_areas/asignar_todo/${empresa}`)
            .then((response)=> {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 3000
                })
                dispatch('getBasesAreas');
                state.selectedBasesAreas.seltodos = false;
                //state.error = false
            })
            .catch((error) => {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.errors,
                    showConfirmButton: true,
                    timer: 5000
                })
                reject(error);
            })
    }
}

